import { createContext, useContext } from "react";
export const AuthConfigContext = createContext(null);
export function useAuthConfig() {
    const config = useContext(AuthConfigContext);
    if (!config)
        throw new Error("useAuthConfig must be used within AuthProvider");
    return config;
}
//# sourceMappingURL=config.js.map